import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const CardHeaderTextContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const CardFooterContainer = styled.div `
  box-sizing: border-box;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${theme.spacing.xl} ${theme.spacing['2xl']};
`;
export const CardContentContainer = styled.div `
  padding: ${({ $noPadding }) => ($noPadding ? 0 : `0 ${theme.spacing['2xl']} ${theme.spacing['2xl']}`)};
  height: 100%;
  background-color: ${theme.semantic.surface.primary};
`;
const boxShadow = (token) => {
    if (!token) {
        return undefined;
    }
    return css `
    box-shadow: ${theme.dropShadow[token]};
  `;
};
const cardBorder = (border = true) => {
    if (!border) {
        return undefined;
    }
    return css `
    border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  `;
};
export const CardHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${theme.spacing['2xl']};
  background-color: ${theme.semantic.surface.primary};
`;
export const CardHeaderContent = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.md};
  align-items: center;
`;
const smallSizeStyles = css `
  ${CardFooterContainer} {
    padding: ${theme.spacing.xl} ${theme.spacing.xl};
  }

  ${CardHeaderContainer} {
    padding: ${theme.spacing.xl};
  }

  ${CardContentContainer} {
    padding: 0 ${theme.spacing.xl} ${theme.spacing.xl};
  }
`;
export const CardContainer = styled.div `
  display: flex;
  flex-direction: row;
  background-color: ${theme.semantic.surface.primary};
  border-radius: ${theme.borderRadius.lg};
  overflow: hidden;
  color: ${theme.semantic.text[200]};

  ${(props) => boxShadow(props.$dropShadow)};
  ${(props) => cardBorder(props.$border)};

  ${({ $size = 'default' }) => ($size === 'small' ? smallSizeStyles : null)};
`;
export const CardFooterActionsContainer = styled.div `
  display: flex;
  gap: ${theme.spacing.xl};
  margin-left: auto;
`;
export const CardMedia = styled.div `
  flex: 0 0 ${(props) => props.$fraction * 100}%;
  background-color: ${theme.swatches.warm[800]};
`;
export const CardBody = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  position: relative;
  min-width: 0;
`;
